import type { CommitmentTierUsageData, PerUnitPricingConfiguration } from '@weft/types';
import type { Currency } from '@weft/types';
import React from 'react';
import { calculateCommitmentUnitsAmount } from './commitment-calculator';
import { LightInvoiceProductItem } from './LightInvoiceProductItem';

type LightInvoiceTiersUsageChargesProps = {
  productVariantId: string;
  pricingConfiguration: PerUnitPricingConfiguration;
  tierUsageMap: Record<string, CommitmentTierUsageData[]>;
  currency: Currency
};

export const LightInvoiceCommitmentPerUnitUsageCharges: React.FC<LightInvoiceTiersUsageChargesProps> = ({ productVariantId, tierUsageMap, pricingConfiguration, currency }) => {
  if (isCommitmentNotCrossed(tierUsageMap, productVariantId)) {
    return (
      <LightInvoiceProductItem
        key={productVariantId + 'commitment'}
        name='Commitment non billable'
        price={0}
        units={calculateCommitmentUnitsAmount(tierUsageMap, productVariantId)}
        currency={currency}
      />
    );
  }

  if (isCommitmentCrossed(tierUsageMap, productVariantId)) {
    return (
      <LightInvoiceProductItem
        key={productVariantId}
        price={pricingConfiguration.price}
        units={tierUsageMap[productVariantId][0].billableUnits}
        currency={currency}
      />
    );
  }

  return (
    <React.Fragment>
      <LightInvoiceProductItem 
        key={productVariantId}
        price={pricingConfiguration.price}
        units={tierUsageMap[productVariantId][0].billableUnits}
        currency={currency}
      />
        
      <LightInvoiceProductItem
        key={productVariantId + 'commitment'}
        name='Commitment non billable'
        price={0}
        units={calculateCommitmentUnitsAmount(tierUsageMap, productVariantId)}
        currency={currency}
      />
    </React.Fragment>
  );
};

function isCommitmentNotCrossed(tierUsageMap: Record<string, CommitmentTierUsageData[]>, productVariantId: string) {
  const variantUsageData = tierUsageMap[productVariantId];

  const singleTierUsageData = variantUsageData[0];

  return singleTierUsageData.billableUnits === 0;
}

function isCommitmentCrossed(tierUsageMap: Record<string, CommitmentTierUsageData[]>, productVariantId: string) {
  const commitmentUnitsAmount = calculateCommitmentUnitsAmount(tierUsageMap, productVariantId);
  
  return commitmentUnitsAmount === 0;
}